import { render, staticRenderFns } from "./ActiveEnquiriesSample.vue?vue&type=template&id=65823b38&scoped=true"
import script from "./ActiveEnquiriesSample.vue?vue&type=script&lang=js"
export * from "./ActiveEnquiriesSample.vue?vue&type=script&lang=js"
import style0 from "./ActiveEnquiriesSample.vue?vue&type=style&index=0&id=65823b38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../mbp_crm-adminclient-align/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65823b38",
  null
  
)

export default component.exports